export const data = [
  {
    id: Math.random() * 10,
    name: "UserDetails",
    fields: [
      {
        id: Math.random() * 10,
        name: "FullName",
        label: "Full Name",
        type: "text",
        isRequired: true,
        ValidationType: "VALID_STRING",
      },
      {
        id: Math.random() * 10,
        name: "mobileNumber",
        label: "Mobile Number",
        type: "number",

        min: 10,
        max: 10,
        isRequired: true,
        ValidationType: "VALID_NUMBER",
      },
    ],
  },
];
